import { useFileInput } from '@codeleap/web'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import { FileInput } from '@/components'
import { WebInputFile } from '@codeleap/types'
import { CropPickerModal, CropPickerModalProps } from './modal'

type CropPickerInputProps = {
  reactCrop?: CropPickerModalProps['reactCrop']
  multiple?: boolean
}

type CropPickerInputRef = {
  pickAndCropImage: () => Promise<WebInputFile | null>
}

export const CropPickerInput = forwardRef<CropPickerInputRef, CropPickerInputProps>((props, ref) => {
  const { multiple = false, reactCrop } = props

  const input = useFileInput()

  const pickAndCropImage = async () => {
    const files = await input.openFilePicker()

    const file = files?.length >= 1 ? files?.[0] : null

    if (file == null) return null

    const cropResult = await CropPickerModal.request({ file, reactCrop })

    return cropResult?.file
  }

  useImperativeHandle(ref, () => ({
    pickAndCropImage
  }))

  return <FileInput multiple={multiple} ref={input.ref} accept="image/*" />
})

export const useCropPickerInputRef = () => {
  const ref = useRef<CropPickerInputRef>(null)

  const pickAndCropImage = () => {
    return ref.current?.pickAndCropImage()
  }

  return {
    pickAndCropImage,
    ref
  }
}
